import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindshieldDriver = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 350 350",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#WindshieldDriver_svg__a)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#WindshieldDriver_svg__b)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M175 350c96.65 0 175-78.35 175-175S271.65 0 175 0 0 78.35 0 175s78.35 175 175 175"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M315.13 133.13a1572 1572 0 0 1 18.13-32.46 176 176 0 0 0-37.17-51.8c-17.19 2.88-66.9 10.8-99 19.79 0 0-31.28 9.45-34.28 10.91-.89.07-1.27-.5-1.27-.5A323 323 0 0 0 140 88.15c-2.94 1.37-48.3 34.6-93.87 74.3A1120 1120 0 0 0 .2 186.88C6.31 277.98 82.14 350 174.8 350q2.6 0 5.17-.08a174.6 174.6 0 0 0 126.27-59.4c-.12-.02-2.05-.43-11.59-2.27-9.86-1.9-14.36-.11-18.1 2-3.72 2.1-30.05 23.98-30.1 24.02a90 90 0 0 1 3.87-23.93c7.47-24.7 51.68-133.28 64.81-157.21m-172.1 182.42C92.22 302.15 41.5 269.2 22.64 216.6c-12.83-35.78 14.37-46.12 23.75-51.68 0 0 74.68-63.28 94.4-75.06l172.73 7.09s-12.2 19.08-21.39 37.6c-9.19 18.5-72.76 147.57-76.6 150.76-3.82 3.19-21.7 43.66-72.5 30.25"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M290.08 200.85c3.8 4.47 5.63 16.15 6.49 33.86.7 14.24 1.53 17.84 1.83 18.7 7.17-9.17 21.25-23.53 23.83-25.3 3.04-2.1 18.67 1.24 18.93 1.3a175 175 0 0 0 8.63-54.41 174 174 0 0 0-14.4-69.6c-.14.27-11.97 21.32-20.53 37.69-3.96 7.55-14.09 31.6-24.78 57.76"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m292.31 45.33 1.4 1.29z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M341.16 229.4c-.26-.05-15.9-3.38-18.93-1.3-2.58 1.78-16.66 16.14-23.83 25.3a46 46 0 0 0-3.17 4.48 10 10 0 0 0-1.58 5.47c.15 5.04 4.72 9.05 7.51 13.24 3.73 5.58 9.9 4.88 12.34 5.1 12-15.56 21.42-33.2 27.66-52.28"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3c3c3b",
					d: "M335.4 105.4q-1.04-2.39-2.15-4.73c-.13.22-5.17 8.84-18.12 32.46-13.13 23.93-57.34 132.5-64.8 157.21a90 90 0 0 0-3.88 23.93c.05-.04 26.38-21.92 30.1-24.02 3.74-2.11 8.24-3.9 18.1-2a757 757 0 0 1 11.58 2.27 177 177 0 0 0 7.27-8.82c-2.43-.23-8.6.47-12.34-5.11-2.8-4.19-7.36-8.2-7.5-13.24-.06-1.7.4-3.5 1.57-5.47a46 46 0 0 1 3.17-4.47c-.3-.86-1.14-4.46-1.83-18.7-.86-17.7-2.68-29.39-6.49-33.86 10.7-26.16 20.82-50.2 24.78-57.76 8.56-16.37 20.39-37.42 20.54-37.68"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3c3c3b",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M215.54 285.3c3.83-3.2 67.4-132.26 76.6-150.77 9.18-18.5 21.38-37.6 21.38-37.6l-172.73-7.08c-19.72 11.78-94.4 75.07-94.4 75.07C37 170.47 9.8 180.8 22.64 216.6c18.86 52.6 69.58 85.55 120.39 98.95 50.8 13.4 68.68-27.06 72.5-30.25m-33.48-11.38c-28.92-9.57-127.5-56.67-130.98-104.94-.67-9.3 74.68-67.6 86.04-73.85 12.38-.38 23.75 1.4 23.75 1.4l-7.54 8.05s-2.42 2.43 3.07 2.94 8.04.86 8.04.86-2.44 3.25.2 3.59c2.62.33 4.44.67 8.47-2.4 5.79.72 10 1.4 11.77 1.63 1.77.24 5.55 1.68 10.92-2.15s14.6-9.58 14.6-9.58 77.17 5.75 81.38 5.75 11.49 0 2.3 15.13-69.9 130.98-73.53 137.68c-3.64 6.7-9.58 25.47-38.5 15.9z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#0bbbef",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M294.28 120.35c9.2-15.13 1.92-15.13-2.3-15.13-4.2 0-81.38-5.75-81.38-5.75s-9.24 5.75-14.6 9.58-9.14 2.4-10.91 2.15c-1.77-.24-5.99-.9-11.78-1.63-4.02 3.07-5.84 2.73-8.47 2.4s-.2-3.6-.2-3.6-2.55-.34-8.04-.86c-5.48-.5-3.06-2.93-3.06-2.93l7.53-8.04s-11.36-1.8-23.74-1.4c-11.37 6.25-86.72 64.54-86.05 73.84 3.48 48.27 102.07 95.37 130.98 104.94 28.92 9.57 34.86-9.2 38.5-15.9 3.63-6.7 64.33-122.55 73.53-137.68z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m295.18 47.99-1.47-1.37q.74.68 1.46 1.37zM292.16 45.19q0 0 0 0l.15.14z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m293.7 46.62-1.39-1.3-.16-.13c-13.07.9-61.87 7.2-88.8 13.83-26.94 6.64-41.81 20.04-41.81 20.04s.38.58 1.27.52c1.8-.89 7.36-2.4 10.16-3.47.95-.73 1.6-1.2 1.6-1.2 3.49-2.55 11.15-7.32 24.12-10.72 0 0 36.57-11.47 96.48-16.2z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m197.18 64.6-1.69 4.54-22.52 6.97s8.44-7.45 24.21-11.51z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2,
					d: "M.53 186.17c.25-.14 20.06-12.4 44.93-24.86 45.57-39.7 90.92-72.94 93.86-74.31s12.6-5.78 21.54-9.1c0 0 14.87-13.4 41.8-20.04 26.94-6.64 75.66-12.35 88.73-13.27"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#3c3c3b",
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "m247.17 326.91 45.18-38.66s-8.82-3.19-15.8 2c-6.96 5.18-30.1 24.02-30.1 24.02s.21 9.66.72 12.64"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M313.35 281.7c-2.44-.23-8.61.47-12.34-5.11-2.8-4.19-7.37-8.2-7.51-13.24-.05-1.7.4-3.5 1.57-5.47a46 46 0 0 1 3.18-4.47c7.17-9.17 21.24-23.53 23.82-25.3 3.04-2.1 18.67 1.24 18.94 1.3m-47.51 33.94c1.4 7.57 18.8 9.76 26.27 9.47"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M333.1 100.67c-.13.22-5.17 8.84-18.12 32.46-13.13 23.93-57.34 132.5-64.81 157.21a90 90 0 0 0-3.88 23.93c.05-.04 26.38-21.92 30.11-24.02 3.74-2.11 8.24-3.9 18.1-2a757 757 0 0 1 11.58 2.27"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M313.35 281.7c-2.44-.23-8.61.47-12.34-5.11-2.8-4.19-7.37-8.2-7.51-13.24-.05-1.7.4-3.5 1.57-5.47a46 46 0 0 1 3.18-4.47c-.3-.86-1.14-4.46-1.84-18.7-.86-17.71-2.68-29.39-6.48-33.86m45.31-95.44c-.14.26-11.98 21.3-20.54 37.68-3.95 7.55-14.08 31.6-24.77 57.76-13.56 33.17-28.02 69.73-31.9 80.3m0 0c-6.97 18.9-7.1 22.02-8.14 30.15 1.05-8.13 1.17-11.26 8.13-30.15M310.23 285.64l-36.89-7.08z"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: .5,
					d: "m214.26 286.83 7.43 2.84 28.63-.77M179.35 315.85l2.51 23.7-1.92 10.45M248.87 333.59s-1.11-2.74-1.67-6.45"
				}),
				/* @__PURE__ */ _jsx("path", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M195.49 69.14c13.49-3.58 58.99-14.45 100.6-20.28"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M156.18 107.99s-77.86 79.74-88.37 94.13c.97 2.02 10.44 10.99 13.88 13.86 19.44-26.85 94.8-105.49 94.8-105.49l-3-.41-2.2 1.44s-2.14 1.36-5.1 1.09c-1.26-.12-4.44 0-2.43-3.83-3.1-.45-7.58-.8-7.58-.8M57.95 188.14c.49 1.09 1.44 2.75 2.78 4.6 10.37-12.28 54.48-56.28 54.48-56.28s-31.9 26.75-57.26 51.68M181.92 111.33c1.91.1 4.24.64 5.64.83-8.85 7.07-43.81 40.82-43.81 40.82s15.76-19.3 38.16-41.65"
				}),
				/* @__PURE__ */ _jsxs("g", {
					stroke: "#1b1a1c",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					opacity: .5,
					children: [
						/* @__PURE__ */ _jsx("path", { d: "m101.26 193.25 26.1 13.84L152 193.95s14.52-8.76 28.41-3.63 46.6 22.15 57.99 33.54M180.42 190.32c-.75-4.92-.33-10.76 9.1-12.1s40.83 8.18 58.77 26.96" }),
						/* @__PURE__ */ _jsx("path", { d: "M187.17 193.05c-.4-3.23 5.85-4.92 24.3 4.17 18.43 9.1 29.44 21.13 29.44 21.13" }),
						/* @__PURE__ */ _jsx("path", {
							strokeWidth: .5,
							d: "M189.52 178.22c-1.34 1.59-3.09 7.47-.34 12.25M243.8 201.04s-2.47 8.06-7.76 12.66"
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M9.76 120.15a5 5 0 0 1-5-5V71.32a5 5 0 0 1 5-5h40.4a5 5 0 1 1 0 10h-35.4v38.83a5 5 0 0 1-5 5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M50.15 66.32a5 5 0 1 1 0 10H14.76v38.83a5 5 0 1 1-10 0V71.32a5 5 0 0 1 5-5zm0-2H9.76a7 7 0 0 0-7 7v43.83a7 7 0 0 0 14 0V78.32h33.4a7 7 0 0 0 0-14"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M340.24 120.15a5 5 0 0 1-5-5V76.32h-35.4a5 5 0 1 1 0-10h40.4a5 5 0 0 1 5 5v43.83a5 5 0 0 1-5 5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M340.24 66.32a5 5 0 0 1 5 5v43.83a5 5 0 1 1-10 0V76.32h-35.4a5 5 0 1 1 0-10zm0-2h-40.4a7 7 0 0 0 0 14h33.4v36.83a7 7 0 0 0 14 0V71.32a7 7 0 0 0-7-7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M50.15 308.61H9.76a5 5 0 0 1-5-5v-43.83a5 5 0 1 1 10 0v38.83h35.4a5 5 0 1 1 0 10"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M9.76 254.78a5 5 0 0 1 5 5v38.83h35.4a5 5 0 1 1 0 10H9.75a5 5 0 0 1-5-5v-43.83a5 5 0 0 1 5-5m0-2a7 7 0 0 0-7 7v43.83a7 7 0 0 0 7 7h40.4a7 7 0 0 0 0-14h-33.4v-36.83a7 7 0 0 0-7-7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "M340.24 308.61h-40.4a5 5 0 1 1 0-10h35.4v-38.83a5 5 0 1 1 10 0v43.83a5 5 0 0 1-5 5"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#1b1a1c",
					d: "M340.24 254.78a5 5 0 0 1 5 5v43.83a5 5 0 0 1-5 5h-40.4a5 5 0 1 1 0-10h35.4v-38.83a5 5 0 0 1 5-5m0-2a7 7 0 0 0-7 7v36.83h-33.4a7 7 0 0 0 0 14h40.4a7 7 0 0 0 7-7v-43.83a7 7 0 0 0-7-7"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "WindshieldDriver_svg__a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h350v350H0z"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "WindshieldDriver_svg__b",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h350v350H0z"
		})
	})] })]
});
export default SvgWindshieldDriver;
